import React, { Component } from "react";

// Global Contexts
import { ShoppingCartContext } from "contexts/shoppingCartContext.js";

import "./quantityAdjustmentArrow.css";

class QuantityAdjustmentArrow extends Component {
  render() {
    return (
      <ShoppingCartContext.Consumer>
        {({ updateLineItems }) => (
          <button
            className={
              this.props.adjustment <= 0
                ? "quantityAdjustmentArrow invert"
                : "quantityAdjustmentArrow"
            }
            onClick={() =>
              updateLineItems([
                {
                  id: this.props.lineItem.id,
                  quantity: this.props.lineItem.quantity + this.props.adjustment
                }
              ])
            }
          >
            <span>↑</span>
          </button>
        )}
      </ShoppingCartContext.Consumer>
    );
  }
}
export default QuantityAdjustmentArrow;

// <p
// className="pointer"
// style={{
//   transform: "rotate(180deg)",
//   position: "absolute",
//   top: "-0.25rem"
// }}
// onClick={() =>
//   this.props.updateLineItems([
//     {
//       id: lineItem.id,
//       quantity: lineItem.quantity - 1
//     }
//   ])
// }
// >
// ↑
// </p>
